// AppRoutes.jsx
import { Routes, Route } from 'react-router-dom';
import User from './Pages/User/User';
import Admin from './Pages/Admin/Admin';
import ProtectedRoute from './Components/ProtectedRoute';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<User />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute requiredRole="admin">
            <Admin />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default AppRoutes;
